import styled from "@emotion/styled";
import { Box, Button, DialogContent, DialogTitle, Paper } from "@mui/material";

export const StyledDraggableDialogTitle = styled(DialogTitle)`
  cursor: move;
  display: flex; 
  align-items: center;
  font-size: 1.2rem;
`;

export const StyledDraggableDialogIconWrapper = styled(Box)`
  margin-right: ${({theme}) => theme.spacing(2)};
  display: flex;
  align-items: center;
`;

export const StyledDraggableDialogContent = styled(DialogContent)`
  max-height: 250px;
  max-width: 300px;
`;

export const StyledDraggableDialogPaper = styled(Paper)`
  position: absolute
`;

export const StyledDraggableDialogClose = styled(Button)`
  margin-left: auto;
`;